import { instance } from 'apis';
import { asyncThunkWrapper } from "helpers/asyncThunkWrapper";

export const getBlob = asyncThunkWrapper({ 
  model: 'blobs', 
  action: 'getBlob', 
  func: async (id) => {
    const attributes = ['id', 'content_type', 'filename', 'url'];
    const response = await instance.get(`/blobs/${id}`, { params: { attributes } });

    return response.data;
  } 
});
export const createBlob = asyncThunkWrapper({ 
  model: 'blobs', 
  action: 'createBlob', 
  func: async ({ name, size, type, checksum, file, onUploadProgress }) => {
    const attributes = ['id', 'content_type', 'filename', 'direct_upload_url', 'direct_upload_headers', 'url'];
    const response = await instance.post(`/blobs/`, { blob: { filename: name, byte_size: size, content_type: type, checksum }, attributes });
    const putUrl = response.data.blob.direct_upload_url;
    const config = {
      headers: response.data.blob.direct_upload_headers,
      onUploadProgress
    };
    await instance.put(putUrl, file, config);

    return response.data;
  } 
});